import React, { 
	//useState, useEffect 
} from 'react'
import { useSelector } from 'react-redux'
import { Link as RouterLink } from 'react-router-dom'

import IconButton from '@mui/material/IconButton';

import RouteConstants from '../routes';
import CartButtonDialog from './CartButtonDialog';

const AppBarButtons = ({showCart, isMain}) => {

	const user = useSelector(state => state.user);
	
	if(user.member_no === 0){
		return null;
	}
	
	return (
	<>
	{showCart ? <CartButtonDialog /> : null}
	{isMain ?
	<RouterLink to={RouteConstants.member.path}>
	<IconButton color="inherit" edge='end' 
	>
	{RouteConstants.member.icon}
	</IconButton>
	</RouterLink>
	: null}
	</>
)};
export default AppBarButtons